import React from 'react';
import {Chip} from "@mui/material";

/**
 * Badge « bêta » discret (menu, titre de page). AJOUT À VALIDER (TOUR-03 lot 3) : aucun token nouveau,
 * il hérite la couleur du texte voisin (`currentColor`), donc lisible sur la sidebar navy comme sur un titre.
 */
function BetaBadge({label = "bêta"}) {
    return (
        <Chip component="span" label={label} size="small" variant="outlined"
              sx={{
                  ml: 1,
                  height: 16,
                  fontSize: '0.6rem',
                  fontWeight: 600,
                  color: 'inherit',
                  borderColor: 'currentColor',
                  opacity: 0.75,
                  verticalAlign: 'middle',
                  '& .MuiChip-label': {px: 0.75},
              }}/>
    );
}

export default BetaBadge;
